<taku-settings-cards [pageTitle]="pageTitle" [pageIconStyleClass]="pageIconStyleClass" [cardsInfo]="cardsInfo">
  <div class="panel-toolbar">
    <taku-zone-switcher (onZoneChanged)="zoneChanged($event)" [selectedZoneId]="activeZoneId"></taku-zone-switcher>
  </div>
</taku-settings-cards>
